import { deriveSaleTimeline, type SaleStateKey, type TimelineSaleData } from './deriveSaleTimeline'
import { saleProgress, type ProgressContext, type ProgressSaleData, type SaleProgressDefinition } from './saleProgress'
import type { ProgressTone } from './styled-components'

export type SaleProductStatus = 'validated' | 'failed' | 'waiting' | 'idle'

const STATUS_BY_STATE: Partial<Record<SaleStateKey, SaleProductStatus>> = {
  signed: 'validated',
  synced: 'validated',
  create_error: 'failed',
  sync_error: 'failed',
  signature_error: 'failed',
  creating: 'waiting',
  created: 'waiting',
  awaiting_signature: 'waiting',
}

const STATUS_BY_TONE: Partial<Record<ProgressTone, SaleProductStatus>> = {
  signed: 'validated',
  error: 'failed',
  wait: 'waiting',
}

export const saleProductStatus = (
  saleData?: TimelineSaleData | null,
  definition?: SaleProgressDefinition,
  context?: ProgressContext,
): SaleProductStatus => {
  if (definition) {
    return STATUS_BY_TONE[saleProgress((saleData ?? {}) as ProgressSaleData, definition, context).tone] ?? 'idle'
  }

  return STATUS_BY_STATE[deriveSaleTimeline(saleData ?? {}).stateKey] ?? 'idle'
}
